import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Standard } from '@getvim/vim-connect';
import { isEmpty } from 'lodash-es';
import useLocalStorage from 'react-localstorage-hook';
import { OrderCreated } from '../../mocks/standard-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';

export const OrderCreatedTab = () => {
  const [payload, setPayload] = useState<Standard.Events.OrderCreatedPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastOrderCreatedPayload', '');
  const [, setShouldPublish] = useLocalStorage('shouldPublishOrderCreated', false);

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(OrderCreated.predefinedPayloads[value]);
  };

  return (
    <Accordion id="orderCreatedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>orderCreated</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          size="small"
          id="order-created-select"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(OrderCreated.predefinedPayloads).map((value) => (
            <MenuItem value={value} key={value} id={`order-created-${value.replaceAll(' ', '-')}`}>
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-order-created"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="orderCreatedPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
